import { BookSeries, BookSeriesItemsForm, BookSeriesItem } from "./components/book-series";
import { formatMoney } from "./components/g-utils";
import { shopifyAPI } from "./api";

class SeriesPage extends BookSeries {
  constructor() {
    super();
  }

  _updateContent(html) {
    const seriesDescriptions = this.querySelectorAll(".js-series-description");
    const seriesItems = this.querySelector(".js-series-items");
    const totalPriceBlock = this.querySelector(".js-total-price-block");
    const totalPrice = this.querySelector(".js-total-price");
    const booksCount = this.querySelector(".js-books-count");
    const seriesBreadcrumb = this.querySelector(".js-series-breadcrumb");
    const ATCBtn = this.querySelector(".js-atc-button");

    let newDescription = this._sectionBatches[0].querySelector(".js-series-description");
    let newseriesBreadcrumb = this._sectionBatches[0].querySelector(".js-series-breadcrumb");
    let newSeriesItems = document.createElement("DIV");
    let newTotalPrice = 0;
    let newBooksCount = 0;

    for (const batch of this._sectionBatches) {
      const curSeriesItems = batch.querySelector(".js-series-items").innerHTML;
      const curTotalPrice = parseInt(batch.querySelector(".js-total-price").innerHTML);
      const curBooksCount = parseInt(batch.querySelector(".js-books-count").innerHTML);

      newSeriesItems.insertAdjacentHTML("beforeend", curSeriesItems);
      newTotalPrice += curTotalPrice;
      newBooksCount += curBooksCount;
    }

    seriesDescriptions.forEach((description) => (description.innerHTML = newDescription.innerHTML));
    seriesItems.innerHTML = newSeriesItems.innerHTML;
    if (newTotalPrice > 0) {
      totalPrice.innerHTML = formatMoney(newTotalPrice);
      totalPriceBlock.classList.remove("jc-hidden");
      if (ATCBtn) ATCBtn.disabled = false;
    } else {
      totalPriceBlock.classList.add("jc-hidden");
      if (ATCBtn) ATCBtn.disabled = true;
    }
    const totalBooksCountEls = this.querySelectorAll(".js-total-books-count");
    totalBooksCountEls.forEach(el => el.innerHTML = this._retailCollection.productIds.length);
    booksCount.innerHTML = newBooksCount;
    seriesBreadcrumb.innerHTML = newseriesBreadcrumb.innerHTML;
  }

  async _updateQuantities() {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    try {
      const cart = await shopifyAPI.cart.getAll();
      const items = cart.items;

      const booksCountEl = this.querySelector(".js-books-count");
      const totalPriceBlockEl = this.querySelector(".js-total-price-block");
      const totalPriceEl = this.querySelector(".js-total-price");
      const itemEls = this.querySelectorAll("series-page-item");
      const ATCBtn = this.querySelector(".js-atc-button");

      itemEls.forEach((item) => {
        item.updateQuantities(items);
      });

      let newBooksCount = 0;
      let newTotalPrice = 0;
      Array.from(itemEls)
        .filter((item) => item.getAttribute("aria-disabled") !== "true")
        .forEach((item) => {
          newBooksCount++;
          newTotalPrice += item.price;
        });

      booksCountEl.textContent = newBooksCount;
      totalPriceEl.textContent = formatMoney(newTotalPrice);
      if (ATCBtn && newTotalPrice > 0) {
        totalPriceBlockEl.classList.remove("jc-hidden");
        ATCBtn.disabled = false;
      } else {
        ATCBtn.disabled = true;
        totalPriceBlockEl.classList.add("jc-hidden");
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  }

  _initStickyAside() {
    const announcementBar = document.querySelector('.js-announcement-bar');
    const header = document.querySelector("#shopify-section-header");

    const stickyElement = this.querySelector(".js-sticky-aside");

    var endScroll,
      currPos = window.scrollY,
      screenHeight = window.innerHeight,
      stickyElementHeight = stickyElement.offsetHeight;

    let topGap = 0,
      bottomGap = 0;

    if(header) {
      topGap = header.offsetHeight;
    }
    if(announcementBar) {
      topGap += announcementBar.offsetHeight;
    }

    stickyElement.style.setProperty("--position-top", topGap + `px`);

    function positionStickySidebar() {
      endScroll = window.innerHeight - stickyElement.offsetHeight - bottomGap;
      let stickyElementTop = parseInt(
        stickyElement.style.getPropertyValue("--position-top").replace(`px;`, ``)
      );
      let stickyElementNewTop;
      if (stickyElementHeight + topGap + bottomGap > screenHeight) {
        let scrollDelta = currPos - window.scrollY;
        if (scrollDelta > 0) {
          stickyElementNewTop = Math.min(stickyElementTop + scrollDelta, topGap);
        } else {
          stickyElementNewTop = Math.max(stickyElementTop + scrollDelta, endScroll);
        }
      } else {
        stickyElementNewTop = topGap;
      }
      stickyElement.style.setProperty("--position-top", stickyElementNewTop + `px`);

      currPos = window.scrollY;
    }

    function updateSticky() {
      screenHeight = window.innerHeight;
      stickyElementHeight = stickyElement.offsetHeight;
      positionStickySidebar();
    }

    window.addEventListener(`resize`, () => {
      topGap = header.offsetHeight;
      currPos = window.scrollY;
      updateSticky();
    });
    //Follow the main function when scrolling
    document.addEventListener(`scroll`, updateSticky, {
      capture: true,
      passive: true,
    });
  }

  connectedCallback() {
    super.connectedCallback();

    this.cart.addEventListener("cart:rerendered", (e) => {
      clearTimeout(this.cartTimoutId);
      this.cartTimoutId = setTimeout(this._updateQuantities.bind(this), 1000);
    });

    this._initStickyAside();
  }
}

class SeriesPageItemsForm extends BookSeriesItemsForm {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
}

class SeriesPageItem extends BookSeriesItem {
  constructor() {
    super();

    this._addToCartBtn = this.querySelectorAll(".js-add-to-cart");
    this._variantsJSON = JSON.parse(this.querySelector(".js-inventory-quantities").innerHTML);
    this._priceEl = this.querySelector(".js-price");
    this._compareAtPriceEl = this.querySelector(".js-compare-at-price");
  }

  connectedCallback() {
    this._addToCartBtn.forEach((el) => {
      el.addEventListener("click", this._addToCart.bind(this));
    });
  }

  async _addToCart(e) {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    const data = await shopifyAPI.cart.addItem(this.variantId, 1, null, { _wasAddedFromBuySeries: true, Auteur: this.author });

    if (data?.items?.length > 0) {
      e.target.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            button: e.target,
            variant: this.variantId,
            quantity: data.items.length,
            properties: { _wasAddedFromBuySeries: true, Auteur: this.author }
          },
        })
      );
      window.jollyFunctions.klaviyoTrackAddToCart(this.atcKlaviyoEventData);
    }
  }

  updateQuantities(cartItems) {
    for (let key of Object.keys(this._variantsJSON)) {
      const inCartCount = cartItems.find((item) => item.variant_id == key)?.quantity || 0;
      this._variantsJSON[key].availableQnt = this._variantsJSON[key].inventoryQnt - inCartCount;
    }

    this._checkAvailability();
  }

  _checkAvailability() {
    let available = false;
    for (let variantId of Object.keys(this._variantsJSON)) {
      if (this._variantsJSON[variantId].availableQnt > 0) {
        this.variantId = variantId;
        available = true;
        break;
      }
    }

    if (!available) {
      this.disable();
    } else {
      this.enable();
    }
  }

  set variantId(id) {
    super.variantId = id;
    const price = this._variantsJSON[id].price;
    const compareAtPrice = this._variantsJSON[id].compareAtPrice;
    this._priceEl.innerHTML = formatMoney(price);
    this._compareAtPriceEl.innerHTML = formatMoney(compareAtPrice);
    if (compareAtPrice > price) {
      this._compareAtPriceEl.setAttribute("aria-hidden", false);
    } else {
      this._compareAtPriceEl.setAttribute("aria-hidden", true);
    }
  }

  get variantId() {
    return super.variantId;
  }

  get price() {
    return this._variantsJSON[this.variantId].price;
  }
}

window.customElements.define("series-page", SeriesPage);
window.customElements.define("series-page-items-form", SeriesPageItemsForm, {
  extends: "form",
});
window.customElements.define("series-page-item", SeriesPageItem);
